module.exports = __webpack_public_path__ + "static/media/facebook.0f97559f.svg";